export default __webpack_public_path__ + "static/media/arrow-up.78a8a6c5.svg";